

.subtitle {
  text-transform: uppercase;
  color: var(--chart-300-icon-buttons);
}

.checkbox-with-input {
  display: flex;
  align-items: center;

  .checkbox-width {
    width: 500px;
  }

  gz-checkbox {
    --form-field-input-width: 500px;
  }
}

.checkbox-subtitle {
  --label-font-size: calc(11px + var(--dynamic-font-size-changer));
  --label-font-family: var(--font-family);
  margin-top: 2px;
}
